import React from "react";
import ct from "class-types.macro";
import LoginLink from "../LoginLink";
import HelpIcon from "./HelpIcon";
import Form from "./GetPriceByTextForm";
interface Props {
  itemNumber: string;
  showLoginLink?: boolean;
  showContactPhoneNumber?: boolean;
  productListingView?: string;
}
const GetPriceByText = ({
  itemNumber,
  showLoginLink,
  showContactPhoneNumber,
  productListingView
}: Props) => {
  const getPriceByTextVerbiage = showLoginLink ? " or get price by text! " : "Get price by text! ";
  return <>
      <p style={{
      minWidth: 155
    }} className={`price enter-email ${ct("font-semibold", "text-xs", "leading-none", "mb-0", "relative", "text-gray-800", "z-5")} ${productListingView === "list" ? ct("pb-0", "text-left", "xs:text-center") : ct("text-center")}`}>
        {showLoginLink && <LoginLink>Login</LoginLink>}
        {getPriceByTextVerbiage}
        <HelpIcon data-sentry-element="HelpIcon" data-sentry-source-file="index.tsx" />
      </p>
      <Form itemNumber={itemNumber} data-sentry-element="Form" data-sentry-source-file="index.tsx" />
      {showContactPhoneNumber && <p className={`${ct("font-semibold", "text-xs", "leading-4-1/8", "mb-0", "w-full")} ${productListingView === "list" ? ct("text-left", "xs:text-center") : ct("text-center")}`}>
          Or call 717-392-7472
        </p>}
    </>;
};
export default GetPriceByText;